import { Repeat2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useCreatePost } from "@/hooks/platform/usePosts";
import { useCurrentUser } from "@/hooks/platform/useCurrentUser";
import { supabase } from "@/integrations/supabase/client";

export const repostSourceId = (tags: string[] | null | undefined) =>
  tags?.find((tag) => tag.startsWith("reshare:"))?.slice(8) ?? null;

/** A repost refers to the original; it never republishes someone else's media. */
const RepostButton = ({ postId, className }: { postId: string; className?: string }) => {
  const { userId } = useCurrentUser();
  const create = useCreatePost();

  const repost = async () => {
    if (!userId) { toast.info("Sign in to repost"); return; }
    try {
      const { data, error } = await supabase.from("posts").select("id").eq("id", postId).eq("visibility", "public").maybeSingle();
      if (error) throw error;
      if (!data) { toast.error("This post is no longer available"); return; }
      await create.mutateAsync({ author_id: userId, content: "Reposted a post", post_type: "post", tags: [`reshare:${postId}`], visibility: "public" });
      toast.success("Reposted to your feed");
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Could not repost");
    }
  };

  return <Button type="button" variant="ghost" size="sm" className={className} disabled={create.isPending} onClick={() => void repost()} title="Repost to your feed"><Repeat2 className="h-4 w-4" /><span className="ml-1">Repost</span></Button>;
};

export default RepostButton;